<app-navigation></app-navigation>
<mat-card class="card">
  <mat-card-content>
    @if (this.patientId === undefined) {
      <h1>Neuer Patient</h1>
    } @else {
      <h1>Patient ändern</h1>
    }

    <form class="input-form" [formGroup]="patientForm">
      <mat-form-field appearance="fill">
        <mat-label>Voller Name</mat-label>
        <input
          (blur)="onNameBlur($event)"
          type="text"
          matInput
          formControlName="name"
          placeholder="Name des Patienten" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>ID</mat-label>
        <input type="text" matInput formControlName="uid" placeholder="ID des Patienten" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-label>Geburtsdatum</mat-label>
        <!-- <mat-hint>Eingabe über Datepicker Icon</mat-hint> -->
        <input
          matInput
          placeholder="Eingabe über Datepicker"
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="picker"
          formControlName="birthDate"
          required
          (blur)="onDateBlur($event)" />
        <!-- <mat-error *ngIf="patientForm.get('birthDate')?.errors">
          {{ patientForm.get('birthDate')?.errors | json }}
        </mat-error> -->
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Geschlecht</mat-label>
        <mat-select formControlName="gender" required>
          <mat-option value="m">Männlich</mat-option>
          <mat-option value="f">Weiblich</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-form-field appearance="fill">
        <mat-label>Geburtsjahr</mat-label>
        <input matInput formControlName="birthYear" type="number" required />
        <mat-error *ngIf="patientForm.get('birthYear')?.hasError('pattern')">
          Gültiges Jahr eingeben (z.B. 2010)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Geburtsmonat</mat-label>
        <input matInput formControlName="birthMonth" type="number" required />
        <mat-error
          *ngIf="patientForm.get('birthMonth')?.hasError('min') || patientForm.get('birthMonth')?.hasError('max')">
          Gültigen Monat eingeben (1-12)
        </mat-error>
      </mat-form-field> -->

      <br />
      <br />
      <br />

      <h2 class="span-full-row title2">Zusätzliche Informationen</h2>
      <mat-form-field class="note span-full-row">
        <mat-label>Diagnose</mat-label>
        <textarea type="text" matInput formControlName="diagnosis" placeholder=""></textarea>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Dominante Seite</mat-label>
        <mat-select formControlName="dominantSide">
          <mat-option value="l">Links</mat-option>
          <mat-option value="r">Rechts</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Betroffene Seite</mat-label>
        <mat-select formControlName="affectedSide">
          <mat-option value="l">Links</mat-option>
          <mat-option value="r">Rechts</mat-option>
          <mat-option value="b">Beide</mat-option>
        </mat-select>
      </mat-form-field>

      @if ($error() !== '') {
        <mat-error>{{ $error() }}</mat-error>
      }
    </form>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="location.back()">Abbrechen</button>
      @if (this.patientId === undefined) {
        <button mat-flat-button color="primary" (click)="createPatient()">Neuen Patient anlegen</button>
      } @else {
        <button mat-flat-button color="primary" (click)="updatePatient()">Änderungen speichern</button>
      }
    </div>
  </mat-card-content>
</mat-card>
